export function logout() {
  localStorage.removeItem("token");
}
